import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../store/hooks';
import { CText, CHeader, CButton } from '../../components/common';
import routes from '../../utils/routes';

interface Language {
  id: string;
  name: string;
  flag: string;
}

const SelectLanguage: React.FC = () => {
  const navigate = useNavigate();
  const colors = useAppSelector((state) => state.theme.theme);

  const languages: Language[] = [
    { id: 'en-us', name: 'English (USA)', flag: '🇺🇸' },
    { id: 'en-uk', name: 'English (UK)', flag: '🇬🇧' },
    { id: 'hi', name: 'Hindi', flag: '🇮🇳' },
    { id: 'es', name: 'Spanish', flag: '🇪🇸' },
    { id: 'fr', name: 'French', flag: '🇫🇷' },
    { id: 'de', name: 'German', flag: '🇩🇪' },
    { id: 'zh', name: 'Chinese', flag: '🇨🇳' },
    { id: 'ja', name: 'Japanese', flag: '🇯🇵' },
    { id: 'ar', name: 'Arabic', flag: '🇸🇦' },
    { id: 'pt', name: 'Portuguese', flag: '🇧🇷' },
  ];

  const [selectedLanguage, setSelectedLanguage] = useState('en-us');

  const handleSave = () => {
    // Save language preference (localStorage or API)
    localStorage.setItem('app_language', selectedLanguage);
    navigate(routes.profile);
  };

  return (
    <div
      className="p-4 lg:p-8 min-h-screen pb-24"
      style={{ backgroundColor: colors.backgroundColor }}
    >
      <div className="lg:max-w-3xl lg:mx-auto">
        <CHeader title="Select Language" />

        <CText type="r14" color={colors.grayScale500} style={{ marginBottom: 24 }}>
          Choose your preferred language
        </CText>

        <div className="space-y-2">
          {languages.map((lang) => {
            const isSelected = selectedLanguage === lang.id;

            return (
              <button
                key={lang.id}
                onClick={() => setSelectedLanguage(lang.id)}
                className="w-full flex items-center justify-between p-4 rounded-xl border transition-colors"
                style={{
                  backgroundColor: isSelected ? colors.primary + '15' : colors.inputBackground,
                  borderColor: isSelected ? colors.primary : colors.borderColor,
                }}
              >
                <div className="flex items-center gap-3">
                  <span className="text-2xl">{lang.flag}</span>
                  <CText
                    type="M14"
                    color={isSelected ? colors.primary : colors.textColor}
                  >
                    {lang.name}
                  </CText>
                </div>

                {/* Radio Indicator */}
                <div
                  className="w-5 h-5 rounded-full border-2 flex items-center justify-center"
                  style={{
                    borderColor: isSelected ? colors.primary : colors.grayScale500,
                  }}
                >
                  {isSelected && (
                    <div
                      className="w-3 h-3 rounded-full"
                      style={{ backgroundColor: colors.primary }}
                    />
                  )}
                </div>
              </button>
            );
          })}
        </div>

        <div className="mt-8">
          <CButton title="Change Language" onPress={handleSave} />
        </div>
      </div>
    </div>
  );
};

export default SelectLanguage;
